import { isLocalHost } from "std/url";

const URL_LOCALHOST = "http://localhost:21574";
const URL_SAND = "http://api.lacto.mercurioapp.com.br";

const url = isLocalHost() ? URL_LOCALHOST : URL_SAND;

export const baseUrl = `${url}/api/v1`;
